/**
 * main.js
 *
 * Bootstraps plugins then mounts the App`
 */

// Global styles
import '@/scss/responsive.scss'
import '@/scss/pit-ui.scss'

// Plugins
import { registerPlugins } from '@/plugins'
import { initSentry } from '@/plugins/sentry'
import initialize_watchers from "/src/store_watchers"
import { consumeMicrosoftRedirect } from '@/utils/oauth'
import { handleStaleChunks } from '@/utils/stale_chunks'

// Components
import App from './App.vue'

// Composables
import { createApp } from 'vue'

// If we're returning from a Microsoft (MSAL) redirect, capture the response
// BEFORE the router touches the URL hash. App.vue then completes login/linking.
consumeMicrosoftRedirect().finally(() => {
    const app = createApp(App)

    if (process.env.NODE_ENV !== 'development') initSentry(app)

    // Before the router: its first navigation may already load a chunk.
    handleStaleChunks()
    registerPlugins(app)

    app.mount('#app')

    // Inits our own watchers
    initialize_watchers()
})